import { composeVerticals } from './compose'
import { VERTICAL_MODULES } from './registry'

export type { VerticalModule, VerticalNavItem, VerticalRoute } from './types'

/**
 * The merged, collision-checked vertical routes + nav items the shell mounts
 * (UID-9). Computed once at module load: `composeVerticals` throws loudly here
 * — before the app can render — if the registry has a colliding/overlapping
 * path, so a bad registration fails fast in dev/CI, never silently.
 */
export const composedVerticals = composeVerticals(VERTICAL_MODULES)
